// 导入流程设计器组件
import SnakerFlowDesigner from './SnakerFlowDesigner'
// 存储组件列表
const components = [
  SnakerFlowDesigner
]
export default {
  install (app: import('vue').App<unknown>): void {
    components.map(component => app.component(component.name, component))
  }
}
